import fetch from '@/plugin/axios'

// 添加分类

export function addFileCategory (data) {
  return fetch({
    url: '/api/common/file-category/add',
    method: 'Post',
    data: data
  })
}

export function updateFileCategory (id, data) {
  return fetch({
    url: '/api/common/file-category/update/' + id,
    method: 'Post',
    data: data
  })
}

export function removeFileCategory (id) {
  return fetch({
    url: '/api/common/file-category/remove/' + id,
    method: 'Get'

  })
}
export function fileCategoryInfo (id) {
  return fetch({
    url: '/api/common/file-category/info/' + id,
    method: 'Get'

  })
}

export function fileCategoryList (data) {
  return fetch({
    url: '/api/common/file-category/list',
    method: 'Post',
    data: data
  })
}
export function fileCategoryOptions () {
  return fetch({
    url: '/api/common/file-category/options',
    method: 'Get'
  })
}

export function fileCategoryParents (id) {
  return fetch({
    url: `/api/common/file-category/parents/${id}`,
    method: 'Get'
  })
}

// 添加分类

export function addFileTag (data) {
  return fetch({
    url: '/api/common/file-tag/add',
    method: 'Post',
    data: data
  })
}

export function updateFileTag (id, data) {
  return fetch({
    url: '/api/common/file-tag/update/' + id,
    method: 'Post',
    data: data
  })
}

export function removeFileTag (id) {
  return fetch({
    url: '/api/common/file-tag/remove/' + id,
    method: 'Get'

  })
}
export function fileTagOption () {
  return fetch({
    url: '/api/common/file-tag/options',
    method: 'Get'
  })
}

export function fileTagInfo (id) {
  return fetch({
    url: '/api/common/file-tag/info/' + id,
    method: 'Get'

  })
}

export function fileTagList (data) {
  return fetch({
    url: '/api/common/file-tag/list',
    method: 'Post',
    data: data
  })
}

export function addFileResource (data) {
  return fetch({
    url: '/api/common/file-resource/add',
    method: 'Post',
    data: data
  })
}

export function fileResourceList (data) {
  return fetch({
    url: '/api/common/file-resource/list',
    method: 'Post',
    data: data
  })
}

export function FileResourceView (ids) {
  return fetch({
    url: '/api/common/file-resource/view',
    method: 'Post',
    data: ids
  })
}

export function addResourceTag (id, ids) {
  return fetch({
    url: '/api/common/file-resource/addTag/' + id,
    method: 'Post',
    data: ids
  })
}

export function delResourceTag (id, ids) {
  return fetch({
    url: '/api/common/file-resource/deleteTag/' + id,
    method: 'Post',
    data: ids
  })
}

export function delFileResource (id) {
  return fetch({
    url: '/api/common/file-resource/delete/' + id,
    method: 'Delete'
  })
}
